exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table>tr>td[data-v-721497ac]{width:30%;height:30px}.margin-5px[data-v-721497ac]{margin-right:5px}.width-20px[data-v-721497ac]{width:20px}.padding-5px[data-v-721497ac]{padding-right:3%;padding-left:3%}table>tr>td[data-v-721497ac]:nth-child(odd){font-weight:600}.table-responsive img[data-v-721497ac]{width:60px}", ""]);

// exports
